import LoginBox from './src/main.js';
LoginBox.install = function (Vue) {
  Vue.prototype.$loginBox = LoginBox;
};
export default LoginBox;



// WEBPACK FOOTER //
// ./src/components/LoginBox/index.js